import React from 'react'

interface FocusShieldProps {
  /** 덮을 입력칸의 id. FormInput·FormTextarea 는 name 을 그대로 id 로 쓴다. */
  targetId: string
  /** 지금 덮을지. 보통 `!(포커스됨 && 글자가 있음)` */
  active: boolean
  /** 오른쪽을 비워 둘 폭(px). 입력칸 안에 버튼이 있을 때 쓴다. */
  rightGap?: number
}

/**
 * 입력칸 위를 덮는 투명한 층.
 *
 * 왜 필요한가 — 자세히보기 댓글칸에서 이미 쓰고 있는 방법이다
 * ---------------------------------------------------------
 * 칸을 **직접** 누르면 iOS 웹킷이 '이 칸을 보이게' 하려고 보이는 영역을 크게
 * 옮긴다(실기기 측정 380px). 앱도 웹뷰를 안 줄이고 있어, 화면이 한 번 밀렸다
 * 돌아오는 모션으로 보인다.
 *
 *   0ms off0 top62 → 1658ms off380 top-698 → 2331ms off0 top62
 *
 * div 를 누르면 이 현상이 없다. div 에는 브라우저의 기본 포커스 동작이 없고,
 * 우리가 preventScroll 로 커서만 놓기 때문이다. 그래서 입력칸 위에 같은 성격의
 * 층을 덮어, 누르는 대상이 입력칸이 아니라 div 가 되게 한다.
 *
 * 기본 동작을 막는 게 아니라 대상이 바뀌는 것이라 키보드를 띄우는 손짓 연결은
 * 그대로 살아 있다. (preventDefault 로 막으면 키보드가 아예 안 올라온다.)
 *
 * 언제 치우나 — 커서 유무가 아니라 '쓸 글자가 있을 때'다. 빈 칸에서는 옮길
 * 커서가 없으니 층을 덮어 둬도 잃는 게 없고, 글이 있을 때만 치워 글자 사이를
 * 짚을 수 있게 한다.
 */
const FocusShield: React.FC<FocusShieldProps> = ({
  targetId,
  active,
  rightGap = 0,
}) => {
  if (!active) return null

  return (
    <div
      className="absolute left-0 top-0 bottom-0 z-[1]"
      style={{ right: rightGap }}
      onClick={() => {
        const el = document.getElementById(targetId) as
          | HTMLInputElement
          | HTMLTextAreaElement
          | null
        el?.focus({ preventScroll: true })
      }}
    />
  )
}

export default FocusShield
